import { render, staticRenderFns } from "./viewTeacher.vue?vue&type=template&id=3d063291&scoped=true&"
import script from "./viewTeacher.vue?vue&type=script&lang=js&"
export * from "./viewTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d063291",
  null
  
)

export default component.exports